import { useEffect, useState } from "react";
import "./Breadcrums.css";
import { Link, useLocation, useParams } from "react-router-dom";
import ApiService from "../../components/Api_services";

const Breadcrumsv2 = ({ productName: externalProductName }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const filterType = params.get("filter_type");
  const currentFullPath = filterType
    ? `${location.pathname}?filter_type=${filterType}`
    : location.pathname;
  let breadcrumsContent = "breadcrums-content_v2";
  const locationState = location.state;
  const fromFilterType = locationState?.fromFilterType;

  // Find product name from fetched productData or from props
  let productName = externalProductName || "";

  // define mapping for specialLv2Map
  const specialLv2Map = [
    {
      path: "/productlist?filter_type=coming_soon",
      className: "lv2-sp_v2",
      label: "Coming Soon",
      title: "COMING SOON",
      description: "",
    },
    {
      path: "/productlist?filter_type=package",
      className: "lv2-sp_v2",
      label: "Packages",
      title: "PACKAGES",
      description: "",
    },
    {
      path: "/productlist?filter_type=new_arrival",
      className: "lv2-sp_v2",
      label: "New Arrivals",
      title: "NEW ARRIVALS",
      description: "",
    },
    {
      path: "/productlist?filter_type=promotion",
      className: "lv2-sp_v2",
      label: "Promotions",
      title: "PROMOTIONS",
      description: "",
    },
    {
      path: "/productlist",
      className: "lv2-sp_v2",
      label: "Products",
      title: "BROWSE PRODUCTS",
      description: "",
    },
    {
      path: "/refundreturnpolicy",
      className: "lv2-sp_v2",
      label: "Refund & Return Policy",
      title: "REFUND & RETURN POLICY",
      description: "",
    },
    {
      path: "/faq",
      className: "lv2-sp_v2",
      label: "FAQ",
      title: "FAQ",
      description: "",
    },
    {
      path: "/privacypolicy",
      className: "lv2-sp_v2",
      label: "Privacy Policy",
      title: "PRIVACY POLICY",
      description: "",
    },
    {
      path: "/termsconditions",
      className: "lv2-sp_v2",
      label: "Terms & Conditions",
      title: "TERMS & CONDITIONS",
      description: "",
    },
  ];

  // lv2Map: any other location beside the one used in specialLv2Map
  const specialPaths = specialLv2Map.map((item) => item.path);
  const isSpecial = specialPaths.includes(currentFullPath);

  const lv2Map = !isSpecial
    ? [
        {
          prefix: "/mywishlist",
          label: "My Wishlist",
          isEndItem: location.pathname === "/mywishlist",
          canNavigate: true,
        },
        {
          prefix: "/myshoppingcart",
          label: "My Shopping Cart",
          isEndItem: location.pathname === "/myshoppingcart",
          canNavigate: true,
        },
        {
          prefix: "/productdetail",
          navigateprefix: fromFilterType
            ? `/productlist?filter_type=${fromFilterType}`
            : "/productlist",
          label: fromFilterType
            ? specialLv2Map.find(
                (item) =>
                  item.path === `/productlist?filter_type=${fromFilterType}`,
              )?.label
            : "Products",
          isEndItem: false,
          canNavigate: true,
        },
        {
          prefix: "/packageproductdetail",
          navigateprefix: "/productlist?filter_type=package",
          label: "Packages",
          isEndItem: false,
          canNavigate: true,
        },
        {
          prefix: "/grouppackagedetail",
          navigateprefix: "/productlist?filter_type=package",
          label: "Packages",
          isEndItem: false,
          canNavigate: true,
        },
        {
          prefix: "/newrequest",
          label: "Service Request",
          isEndItem: location.pathname === "/newrequest",
          canNavigate: true,
        },
        {
          prefix: "/brandservicecenter",
          label: "Service Center Locations",
          isEndItem: location.pathname === "/brandservicecenter",
          canNavigate: true,
        },
        {
          prefix: "/explorebrand",
          label: "Brands",
          isEndItem: location.pathname === "/explorebrand",
          canNavigate: true,
        },
        {
          prefix: "/exploreproduct",
          label: "Products",
          isEndItem: location.pathname === "/exploreproduct",
          canNavigate: true,
        },
        {
          prefix: "/allorder",
          label: "My Orders",
          isEndItem: location.pathname === "/allorder",
          canNavigate: true,
        },
        {
          prefix: "/checkout",
          navigateprefix: "/myshoppingcart",
          label: "My Shopping Cart",
          isEndItem: false,
          canNavigate: true,
        },
        {
          prefix: "/", // catch all other locations
          label: "Unknown",
          isEndItem: true,
        },
      ]
    : [];

  // find the matching breadcrumb
  const specialLv2Item = specialLv2Map.find(
    (item) => currentFullPath === item.path,
  );

  const lv2Item = lv2Map.find((item) =>
    currentFullPath.startsWith(item.prefix),
  );

  // add dynamic lv3Item for subcategory
  let lv3Item = null;
  if (
    (location.pathname.includes("/productdetail/") && productName) ||
    (location.pathname.includes("/packageproductdetail/") && productName) ||
    (location.pathname.includes("/grouppackagedetail/") && productName)
  ) {
    lv3Item = {
      label: productName,
    };
  } else if (location.pathname.startsWith("/checkout")) {
    lv3Item = { label: "Checkout" };
  }

  return (
    <div className="breadcrums_v2">
      <div className="breadcrums-top-container_v2">
        <div className="breadcrums-top_v2">
          <div className="lv1_v2">
            <Link to="/">Home&nbsp;/&nbsp;</Link>
          </div>

          <div className="lv2">
            {specialLv2Item && (
              <div className={specialLv2Item.className}>
                <span>{specialLv2Item.label}</span>
              </div>
            )}
            {lv2Item &&
              (lv2Item.isEndItem ? (
                <div className="lv2-enditem_v2">
                  <span>{lv2Item.label}</span>
                </div>
              ) : (
                <div className="lv2-item_v2">
                  {lv2Item.canNavigate === true ? (
                    <Link
                      to={lv2Item.navigateprefix ?? lv2Item.prefix}
                      style={{ textDecoration: "none", color: "#717182" }}
                    >
                      {lv2Item.label}&nbsp;/&nbsp;
                    </Link>
                  ) : (
                    <span>{lv2Item.label}&nbsp;/&nbsp;</span>
                  )}
                </div>
              ))}
          </div>

          <div className="lv3_v2">
            {lv3Item && (
              <div className="lv3-item_v2">
                <span>{lv3Item.label}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {specialLv2Item && (
        <div className="breadcrums-bottom-container_v2">
          <div className="breadcrums-bottom_v2">
            <div className="lv2-title_v2">{specialLv2Item.title}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Breadcrumsv2;
